module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "app-title font-red "
  }, [_vm._v("Davivienda Styleguide")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Listas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-list', {
    staticClass: "animated fadeInUp",
    attrs: {
      "lista": _vm.lista
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-list', {
    staticClass: "animated fadeInUp",
    attrs: {
      "lista": _vm.lista,
      "bullet": "bullet-dav-ok"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-list', {
    staticClass: "animated fadeInUp",
    attrs: {
      "lista": _vm.lista,
      "bullet": "bullet-dav"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Botones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('ui-button', {
    attrs: {
      "content": 'Primary button',
      "botSize": 250,
      "aria": 'primary-button'
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogOne = true
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('ui-button', {
    attrs: {
      "secondary": "",
      "content": 'Secondary button',
      "botSize": 350,
      "aria": 'secondary-button'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "text-xs-center": ""
    }
  }, [_c('ui-button-circle-secondary', {
    attrs: {
      "aria": 'Ejemplo de botón secundario'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('ui-button-circle', {
    attrs: {
      "partOne": 'Certificados',
      "partTwo": 'de deposito a termino ',
      "partThree": 'CDT',
      "aria": 'ejemplo de boton'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('ui-button-circle', {
    attrs: {
      "partOne": 'Cuentas',
      "partTwo": 'Corrientes',
      "aria": 'otro ejemplo de boton'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Lista de botones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "text-xs-center": ""
    }
  }, [_c('ui-botslidelist', {
    attrs: {
      "botsNames": _vm.bots
    },
    on: {
      "currentBot": _vm.currentBotOne
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, _vm._l((_vm.bots), function(texto, index) {
    return (_vm.contenidoUno === (index + 1)) ? _c('p', {
      staticClass: "animated fadeInRight",
      attrs: {
        "role": _vm.contenidoUno === (index + 1) ? 'alert' : ''
      }
    }, [_vm._v("\n      " + _vm._s(texto.cont) + "\n    ")]) : _vm._e()
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('ui-topnav', {
    attrs: {
      "botsNames": _vm.botsDos
    },
    on: {
      "currentBot": _vm.currentBotTwo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, _vm._l((_vm.botsDos), function(texto, index) {
    return (_vm.contenidoDos === (index + 1)) ? _c('p', {
      staticClass: "animated fadeInUp",
      attrs: {
        "role": _vm.contenidoDos === (index + 1) ? 'alert' : ''
      }
    }, [_vm._v("\n      " + _vm._s(texto) + "\n    ")]) : _vm._e()
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Titulos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Titulo derecha"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-title-cen', {
    attrs: {
      "title": "Titulo centrado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "app-title font-red "
  }, [_vm._v("Style red")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('ui-title-one', {
    attrs: {
      "titleAccess": "Título de pantalla",
      "titleLevel": "h2"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Titulo"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("de")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("pantalla")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('ui-title-one', {
    attrs: {
      "titleAccess": "Los Bancos reciben dinero de sus clientes a través de",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Los Bancos reciben dinero"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("de sus clientes a través de")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Cuales son?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Cuales")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("son?")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('ui-title-two', {
    attrs: {
      "titleAccess": "¿Que son?",
      "titleLevel": "h2"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Que")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("Son?")])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Videos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Video youtube")]), _vm._v(" "), _c('video-app', {
    attrs: {
      "vidTittle": "Lenguaje de señas",
      "videoSize": 500,
      "youtubeEmbed": "TSuXenPuOgQ"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Video local")]), _vm._v(" "), _c('video-app', {
    attrs: {
      "vidTittle": "Animación",
      "videoSize": 500,
      "videoEmbed": "bunny.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Ventana con video en lenguaje de señas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "text-xs-center": ""
    }
  }, [_c('accesvideo-app', {
    attrs: {
      "vidTittle": "Lenguaje de señas",
      "videoSize": 700,
      "youtubeEmbed": "TSuXenPuOgQ"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "text-xs-center": ""
    }
  }, [_c('accesvideo-app', {
    attrs: {
      "vidTittle": "Lenguaje de señas",
      "videoSize": 700,
      "videoEmbed": "bunny.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Num styles")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-circle-span', {
    attrs: {
      "botProp": ['1', 'circ-gran', 'back-red'],
      "aria": 'Item número uno'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-circle-span', {
    attrs: {
      "botProp": ['2', '', 'back-orange'],
      "aria": 'Item número dos'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('ui-circle-span', {
    attrs: {
      "botProp": ['3', 'circ-peq', 'back-red'],
      "aria": 'Item número tres'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('ui-act-preguntas01', {
    attrs: {
      "actividad": _vm.actividad
    }
  })], 1), _vm._v(" "), _c('banner-slide-app', {
    attrs: {
      "numeroBotones": 4
    }
  }, [_c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont0"
    },
    slot: "cont0"
  }, [_vm._v("\n      Contenido 1\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight text-xs-center",
    attrs: {
      "slot": "cont1"
    },
    slot: "cont1"
  }, [_vm._v("\n      Contenido 2\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont2"
    },
    slot: "cont2"
  }, [_vm._v("\n      Contenido 3\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont3"
    },
    slot: "cont3"
  }, [_vm._v("\n      Contenido 4\n    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Fin del curso")])]), _vm._v(" "), _c('ui-finalcurso', {
    staticClass: "animated rotateIn"
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogOne),
      callback: function($$v) {
        _vm.dialogOne = $$v
      },
      expression: "dialogOne"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Titulo")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vestibulum felis condimentum fringilla tempor. Ut sagittis elementum diam, eget ultrices lacus. Nullam venenatis\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogOne = false
      }
    }
  }, [_vm._v("cerrar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-439777c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Styleguide.vue
// module id = 967
// module chunks = 1